import { useState, useEffect } from "react";
import { connect } from "react-redux";
import { BiErrorCircle } from "react-icons/bi";
import moment from "moment";
import toast from "react-hot-toast";

import ActiveCard from "./ActiveCard";
import CustomApplePayButton from "../../../common/CustomApplePayButton";
import CustomGooglePayButton from "../../../common/CustomGooglePayButton";
import CustomButton from "../../../common/CustomButton";
import PBCardDetails from "../../indi-plan/components/PBCardDetails";

import { UpdateBilling } from "../../../redux/v2/user/actions";
import { SetModalProperties, ShowModal } from "../../../redux/v2/utils/actions";

function Billing(props) {
    const { account } = props.User;
    const billing = account?.billingInfo;
    const isCancelled = billing?.hasCanceledSubscription;

    const [billingDetails, setBillingDetails] = useState({
        name: {
            first: "",
            last: "",
        },
        creditCardNumber: "",
        expiration: {
            date: "",
            cvv: "",
        },
        postal: "",
    });

    const currentBillingDetails = {
        creditCardNumber: billing?.hasOwnProperty("cardNumber") ? "XXXX-XXXX-XXXX-" + billing?.cardNumber : "----",
        cardType: billing?.hasOwnProperty("cardType2") ? billing?.cardType2?.toUpperCase().split("_").join(" ") : "----",
        billingCycle: billing?.hasOwnProperty("createdAt") ? (billing?.plan?.code.indexOf("month") != -1 ? "MONTHLY" : "ANNUAL") : "----",
        nextBillDate: billing?.hasOwnProperty("createdAt") ? moment(new Date(billing?.currentPeriodEndsAt)).format("L") : "----",
    };

    useEffect(() => {
        localStorage.setItem("current-selected-plan", JSON.stringify(billing?.plan));

        if (billing?.hasOwnProperty("createdAt")) {
            setBillingDetails({
                ...billingDetails,
                name: {
                    ...billing?.cardOwner,
                },
            });
        }
    }, [billing?.createdAt]);

    const updateCardDetails = async ({ err, token, formDetails, toastId }) => {
        if (err) {
            toast.error("An error occurred. Please try again!", {
                id: toastId,
            });
        } else {
            const res = await props.UpdateBilling({
                token: token,
                plan: {
                    id: billing?.plan?.id,
                    code: billing?.plan?.code,
                },
                subscriptionID: billing?.subscription_id,
            });

            if (res.success) {
                props?.ShowModal(false);
                toast.success("Card successfully updated!", {
                    id: toastId,
                });
            }
        }

    };

    const updateBillingUsingApplePay = async (token) => {
        const plan = JSON.parse(localStorage.getItem("current-selected-plan"));

        const res = await props.UpdateBilling({
            token: token,
            plan: {
                id: plan?.id,
                code: plan?.code,
            },
            subscriptionID: billing?.subscription_id,
        });

        if (res.success) {
            toast.success("Billing details successfully updated");
        }

    };

    const updateBillingUsingGooglePay = async (token) => {
        const res = await props.UpdateBilling({
            token: token,
            plan: {
                id: billing?.plan?.id,
                code: billing?.plan?.code,
            },
            subscriptionID: billing?.subscription_id,
        });

        if (res.success) {
            toast.success("Billing details successfully updated");
        }

    };

    const dt = localStorage.getItem("indi-device-type");

    return (
        <div id="billing-form" className="my-account-form">
            {billing?.hasOwnProperty("createdAt") && billing?.hasPastDueInvoice ? (
                <div className="past-due-notice-area">
                    <BiErrorCircle />
                    <p>YOUR ACCOUNT IS PAST DUE</p>
                </div>
            ) : (
                ""
            )}

            {account?.user?.company ? (
                <div className="row">
                    <ActiveCard type="billing" />
                </div>
            ) : (
                <div className="row">
                    <div className="col-md-12">
                        <h4>CURRENT BILLING</h4>
                    </div>

                    <div className="col-md-12 mb-4">
                        <div className="row">
                            <div className="col-md-6 acc-detail">
                                <p>CARD NUMBER:</p>
                                <p>{currentBillingDetails?.creditCardNumber}</p>
                            </div>
                            <div className="col-md-6 acc-detail">
                                <p>CARD TYPE: </p>
                                <p>{currentBillingDetails?.cardType}</p>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-6 acc-detail">
                                <p>BILLING CYCLE: </p>
                                <p>{currentBillingDetails?.billingCycle}</p>
                            </div>
                            <div className="col-md-6 acc-detail">
                                <p>NEXT BILL DATE:</p>
                                <p>{isCancelled ? "NONE" : currentBillingDetails?.nextBillDate}</p>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-12 flex-c">
                        <CustomButton
                            style={{ width: "220px" }}
                            onClick={() => {
                                props.SetModalProperties({
                                    height: "320px",
                                    isShow: true,
                                    title: "",
                                    body: (
                                        <>
                                            <PBCardDetails
                                                type="update"
                                                selectedPlan={null}
                                                callback={(response) => {
                                                    updateCardDetails({
                                                        ...response,
                                                    });
                                                }}
                                            />
                                        </>
                                    ),
                                    actions: [],
                                });
                            }}
                        >
                            UPDATE CARD DETAILS
                        </CustomButton>
                    </div>

                    <div className="col-md-12" style={{ marginTop: "10px" }}>
                        <div className="row billing-buttons">
                            <CustomGooglePayButton
                                plan={null}
                                googlePayCallButtonback={(token) => {
                                    updateBillingUsingGooglePay(token);
                                }}
                            />

                            {dt === "ios" && (
                                <CustomApplePayButton
                                    type="update"
                                    plan={null}
                                    applePayCallButtonback={(token) => {
                                        updateBillingUsingApplePay(token);
                                    }}
                                />
                            )}
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

const mapStateToProps = (state) => ({
    User: state.User,
});

export default connect(mapStateToProps, {
    UpdateBilling,
    SetModalProperties,
    ShowModal,
})(Billing);
